<template>
  <Drawer class-name="aqt-drawer-box-zh" :mask-closable="false" :transfer="transfer" :inner="inner" :title="title" v-model="modalState"
          :mask="mask" :width="alasi" scrollable :styles="styles" @on-visible-change="visibleChange"
          @on-close="closableClick" ref="visibleChange">
    <div class="drawer-header-zh" slot="header">
      {{ title }}
      <div class="operation">
        <slot name="operation"></slot>
      </div>
      <div class="telescopic">
        <Icon type="ios-contract" v-if="alasi == 50" @click="telescopicClick(100)" size="16"/>
        <Icon type="ios-expand" v-if="alasi == 100" @click="telescopicClick(50)" size="16"/>
      </div>
    </div>
    <div class="aqt-drawer-zh" v-if="modalState">
      <slot></slot>
    </div>
  </Drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    },
    title: {
      type: [Number, String],
      default: '操作'
    },
    width: {
      type: [Number, String],
      default: 100
    },
    transfer: {
      type: Boolean,
      default: false
    },
    inner: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      alasi: 100,
      styles: {
        height: 'calc(100% - 52px)',
        overflow: 'auto',
        // paddingBottom: '53px'
      },
    }
  },
  computed: {
    modalState: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    telescopicClick(val) {
      this.alasi = val
    },
    visibleChange(bool) {
    },
    closableClick() {
      this.$emit('closeside', false)
      this.modalState = false
    }

  },
  created() {
    this.alasi = this.width
  },
};
</script>
<style>
.aqt-drawer-box-zh .ivu-drawer-inner {
  transition: all .5s;
}
</style>

<style lang="less" scoped>
.aqt-drawer-box-zh {
  .aqt-drawer-zh {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .drawer-header-zh {
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #17233d;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;

    .telescopic {
      position: absolute;
      right: 25px;
      top: 0;
      cursor: pointer;
    }

    .operation {
      margin-left: 10px;
      overflow: hidden;
    }
  }
}

</style>

